export function reports_enabled({store, nextMiddleware}) {
  if (store.state.Auth.user.reports_enabled == 0) {
    return
  } 
  return nextMiddleware();
}

export function options_enabled({store, nextMiddleware}) {
  if (store.state.Auth.user.options_enabled == 0) {
    return
  } 
  return nextMiddleware();
}